module.exports = __webpack_public_path__ + "img/persona.8eb86141.svg";